import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';

import {
    setTypesSig, getTypesSig
} from '../../actions'
import { toast } from 'react-toastify';

class ModalFormTiposSig extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen: true,
            file: undefined
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
    }

    openModal() {
        //this.setState({modalIsOpen: true});
        this.props.openModal()
    }

    closeModal() {
        //console.log(this.props)
        this.props.closeModal()
        //this.setState({modalIsOpen: false});
    }

    handleInputChange(event){
        this.setState({
            [event.target.name]: event.target.value 
        })
    }

    onSubmitForm(event){
        event.preventDefault()
        const { descricao } = this.state
        this.props.setTypesSig( descricao, res => {
            if(res) {
                const { msg_response } = this.props.signatario
                this.setState({  descricao: ''})
                toast.success(msg_response)
                document.querySelector('#modalFormTiposSig .close').click()
                this.props.getTypesSig()
            }
        })
    }
    
    render(){
        const { load_signatario, msg_response, error_response } = this.props.signatario
        return(
            <div className="modal fade" id="modalFormTiposSig" tabIndex="-1" role="dialog" aria-labelledby="modalAddTipo"
            aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <form onSubmit ={this.onSubmitForm}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="modalAddTipo">Adicionar Tipo de signatario</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label  className="sr-only">Descrição/Título</label>
                                    <input name="descricao" type="text" value={this.state.descricao} className="form-control" placeholder="Descrição" required onChange={this.handleInputChange} />
                                </div>
                            </div>
                            
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.closeModal}>Cancelar</button>
                                <button type="submit" className="btn btn-primary"  disabled={load_signatario}>
                                    {load_signatario ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                                {load_signatario ? 'Aguarde...' : 'Adicionar'} 
                                </button>
                            </div>
                        </form>

                        {msg_response != ''
                            ?<div className={`alert alert-${error_response ? 'danger' : 'success'}`} role="alert" style={{marginTop:'1%'}}>
                                {msg_response}
                            </div>
                            :null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ documentos, signatario }) => {
    return {
        documentos, signatario
    }
}

export default connect(mapStateToProps, {
    setTypesSig, getTypesSig
})(ModalFormTiposSig);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}